import React from 'react';
import { Header } from '../dealflow/Header';
import { Footer } from '../dealflow/Footer';
export function CalculatorConfirmation() {
  return <div className="w-full min-h-full bg-white text-black" data-id="element-38">
      <div className="bg-dark-900" data-id="element-39">
        <Header data-id="element-40" />
      </div>
      <div className="max-w-3xl mx-auto px-4 py-16 md:py-24 text-center" data-id="element-41">
        <div className="mb-8" data-id="element-42">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-[#00be60] rounded-full mb-6" data-id="element-43">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="text-white" data-id="element-44">
              <polyline points="20 6 9 17 4 12" data-id="element-45"></polyline>
            </svg>
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-black mb-4" data-id="element-46">
            Your Calculator Is On The Way!
          </h1>
          <p className="text-xl text-gray-600 mb-8" data-id="element-47">
            We've sent the Deal Flow Cost Calculator to your email inbox.
          </p>
        </div>
        <div className="bg-gray-50 border border-gray-200 rounded-xl p-6 md:p-8 mb-10" data-id="element-48">
          <h2 className="text-xl font-bold text-black mb-4" data-id="element-49">Next Steps:</h2>
          <ol className="text-left space-y-4 text-gray-700" data-id="element-50">
            <li className="flex items-start" data-id="element-51">
              <span className="flex-shrink-0 flex items-center justify-center w-7 h-7 bg-[#00be60] text-white rounded-full mr-3 font-bold" data-id="element-52">
                1
              </span>
              <span data-id="element-53">
                Check your email inbox for the calculator (it should arrive
                within 5 minutes)
              </span>
            </li>
            <li className="flex items-start" data-id="element-54">
              <span className="flex-shrink-0 flex items-center justify-center w-7 h-7 bg-[#00be60] text-white rounded-full mr-3 font-bold" data-id="element-55">
                2
              </span>
              <span data-id="element-56">
                <strong data-id="element-57">Don't see it?</strong> Please check your spam,
                promotions, or junk folders
              </span>
            </li>
            <li className="flex items-start" data-id="element-58">
              <span className="flex-shrink-0 flex items-center justify-center w-7 h-7 bg-[#00be60] text-white rounded-full mr-3 font-bold" data-id="element-59">
                3
              </span>
              <span data-id="element-60">
                Use the calculator to determine your exact Meta ads costs for
                deal sourcing
              </span>
            </li>
          </ol>
        </div>
        <div className="text-center" data-id="element-61">
          <a href="/calculator" className="text-[#00be60] hover:text-[#00a853] font-medium" data-id="element-62">
            ← Return to calculator page
          </a>
        </div>
      </div>
      <Footer data-id="element-63" />
    </div>;
}